import React from "react";
import styles from "./CategoryBox.module.scss";
import {
    farmacias,
    refeicao,
    abastecimento,
    outros,
    alimentacao,
} from "assets/images";

const CategoryBox = ({
    filtrar,
    onClick,
    categoria,
    setZoom,
    setIsSeenOnMap,
    setFilterText
}) => {
    let categoryIcon = null;

    switch (categoria.nome) {
        case "FARMÁCIAS":
            categoryIcon = farmacias;
            break;

        case "OUTROS":
            categoryIcon = outros;
            break;

        case "RESTAURANTES":
            categoryIcon = refeicao;
            break;

        case "POSTOS DE COMBUSTÍVEIS":
            categoryIcon = abastecimento;
            break;

        case "SUPERMERCADOS":
            categoryIcon = alimentacao;
            break;

        default:
            categoryIcon = outros;
            break;
    }

    return (
        <div
            className={styles.categoryFilterBox}
            onClick={() => {
                filtrar(null, categoria.nome);
                setFilterText(categoria.nome);
                setZoom(14);
                setIsSeenOnMap(false);
                if (onClick) {
                    onClick();
                }
            }}
        >
            <div className={styles.icon}>
                <img
                    src={categoryIcon}
                    alt={categoria.nome}
                    className={styles.iconCategory}
                />
            </div>
            <div className={styles.name}>{categoria.nome}</div>
        </div>
    );
};
export default CategoryBox;